import { render, staticRenderFns } from "./BranchOrPersonalGiro.vue?vue&type=template&id=466560b8"
import script from "./BranchOrPersonalGiro.vue?vue&type=script&lang=js"
export * from "./BranchOrPersonalGiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports